// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 1179550365
import { createAction } from 'typesafe-actions';

export const clearActAsUser = createAction('MULTI_HOUSEHOLD/CLEAR_ACT_AS_USER')();

export const setActAsUser = createAction('MULTI_HOUSEHOLD/SET_ACT_AS_USER')<string>();
